import { DynamicDisclosures } from './DynamicDisclosures';

export interface ContainerProps {
    /** Callback when disclosure state changes (ready to continue or not) */
    onChange?: (canContinue: boolean, base64Signature: string | null, token: string | null) => void;
    /** Optional type of disclosure, such as "solar" */
    type?: string;
    /** Optional business unit ID if separate financing account */
    buId?: string;
}

/**
 * Container component for dynamic disclosures that provides store context
 * and manages the overall state of the dynamic disclosure feature
 */
export const Container = ({ onChange, type, buId }: ContainerProps) => {
    return <DynamicDisclosures onChange={onChange} type={type} buId={buId} />;
};
